module.exports = __webpack_public_path__ + "static/media/Dribbble.7e3dcca4.svg";